import {create} from 'zustand';
import {CharacterRosterEntryDTO} from '@hexcrawl/shared-utils';
import {lobbyService} from '../services/lobbyService';

interface LobbyStore {
  roster: CharacterRosterEntryDTO[];
  isLoading: boolean;
  error: string | null;
  fetchRoster: () => Promise<void>;
  clearRoster: () => void;
}

export const useLobbyStore = create<LobbyStore>((set) => ({
  roster: [],
  isLoading: false,
  error: null,

  fetchRoster: async () => {
    set({isLoading: true, error: null});
    try {
      const roster = await lobbyService.getRoster();
      set({roster, isLoading: false});
    } catch (e: any) {
      set({error: e?.message || 'Failed to load roster', isLoading: false});
    }
  },

  clearRoster: () => set({roster: [], error: null}),
}));
